<!-- =========================================================================================
    File Name: TheFooter.vue
    Description: Footer component
    Component Name: TheFooter
    ----------------------------------------------------------------------------------------
    Item Name: Vuesax Admin - VueJS Dashboard Admin Template
      Author: Pixinvent
    Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->


<template>
  <footer class="the-footer flex-wrap justify-between" :class="classes">
    <span>
      © {{ new Date().getFullYear() }} Infinity Energy s.r.o
    </span>
    <span class="md:flex hidden items-center">
      <span><a target="_blank" href="https://www.iklient.cz/o-nas/">O nás</a> | <a target="_blank" href="https://www.iklient.cz/smluvni-podminky/">Smluvní podmínky</a> | <a href="mailto:podpora@iklient.cz">podpora@iklient.cz</a></span>
      <feather-icon icon="HeartIcon" svgClasses="stroke-current text-danger w-6 h-6" class="ml-2" />
    </span>
  </footer>
</template>

<script>
export default {
  name: "the-footer",
  props: {
    classes: {
      type: String
    }
  }
};
</script>
